/* eslint-disable vue/no-bare-strings-in-template,
@intlify/vue-i18n/no-raw-text, prettier/prettier */
<script>
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text, prettier/prettier */
import { isAccountAdministrator } from './whatsappGroupsAccess';

// Largura mínima do menu Mais (min-w-64) e margem da tela, para o menu
// teleportado não sair da viewport no celular.
const MORE_MENU_WIDTH = 256;
const VIEWPORT_GUTTER = 16;

export default {
  name: 'WhatsappGroupsLayout',
  data() {
    return {
      moreOpen: false,
      moreMenuStyle: {},
    };
  },
  computed: {
    isAdmin() {
      return isAccountAdministrator(this.$store);
    },
    accountId() {
      return this.$route.params.accountId;
    },
    basePath() {
      return '/app/accounts/' + this.accountId + '/whatsapp-groups';
    },
    primaryTabs() {
      return [
        {
          key: 'dashboard',
          label: 'Visão geral',
          icon: 'i-ri-dashboard-line',
          to: this.basePath + '/overview',
          exact: true,
        },
        {
          key: 'campaigns',
          label: 'Campanhas',
          icon: 'i-ri-megaphone-line',
          to: this.basePath + '/campaigns',
          exact: false,
        },
        {
          key: 'groups',
          label: 'Grupos',
          icon: 'i-ri-group-line',
          to: this.basePath + '/groups',
          exact: false,
        },
      ];
    },
    // Disparo avulso e Entrada automática só respondem a administrador no
    // servidor; para os outros papéis o item não aparece.
    moreSections() {
      const sections = [
        {
          key: 'history',
          items: [
            {
              key: 'messages',
              label: 'Histórico de disparos',
              icon: 'i-ri-history-line',
              to: this.basePath + '/messages',
            },
          ],
        },
        {
          key: 'rest',
          items: [
            {
              key: 'sequences',
              label: 'Sequências',
              description: 'Automações por membro após entrar no grupo',
              icon: 'i-ri-list-ordered',
              to: this.basePath + '/sequences',
              advanced: true,
            },
            {
              key: 'adhoc',
              label: 'Disparo avulso',
              icon: 'i-ri-send-plane-line',
              to: this.basePath + '/messages?adhoc=1',
              advanced: true,
              adminOnly: true,
            },
            {
              key: 'webhooks',
              label: this.$t('WORKSPACE_V2.WA_GROUPS.NAV.WEBHOOKS'),
              description: this.$t(
                'WORKSPACE_V2.WA_GROUPS.NAV.WEBHOOKS_DESCRIPTION'
              ),
              icon: 'i-ri-webhook-line',
              to: this.basePath + '/webhooks',
              adminOnly: true,
            },
            {
              key: 'activities',
              label: 'Atividades',
              icon: 'i-ri-pulse-line',
              to: this.basePath + '/activities',
            },
          ],
        },
      ];
      return sections
        .map(section => ({
          ...section,
          items: section.items.filter(item => !item.adminOnly || this.isAdmin),
        }))
        .filter(section => section.items.length > 0);
    },
    moreTabsFlat() {
      return this.moreSections.flatMap(section => section.items);
    },
    moreActive() {
      return this.moreTabsFlat.some(tab => this.isActive(tab));
    },
  },
  watch: {
    $route() {
      this.moreOpen = false;
    },
  },
  mounted() {
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onDocumentKeydown);
    window.addEventListener('resize', this.closeMore);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onDocumentKeydown);
    window.removeEventListener('resize', this.closeMore);
  },
  methods: {
    onDocumentKeydown(event) {
      if (!this.moreOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.moreOpen = false;
        this.$nextTick(() => this.$refs.moreButton?.focus());
        return;
      }

      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      const items = Array.from(
        this.$refs.moreMenuList?.querySelectorAll('[role="menuitem"]') || []
      );
      if (!items.length) return;
      event.preventDefault();
      const current = items.indexOf(document.activeElement);
      let next = 0;
      if (event.key === 'End') next = items.length - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'ArrowUp')
        next = current <= 0 ? items.length - 1 : current - 1;
      else next = current < 0 || current === items.length - 1 ? 0 : current + 1;
      items[next].focus();
    },

    onDocumentClick(event) {
      if (!this.moreOpen) return;
      const trigger = this.$refs.moreMenu;
      const list = this.$refs.moreMenuList;
      if (trigger?.contains(event.target) || list?.contains(event.target))
        return;
      this.moreOpen = false;
    },

    closeMore() {
      this.moreOpen = false;
    },

    // O menu vai para o body (Teleport) porque a barra de abas rola na
    // horizontal no celular, e overflow na nav cortava o dropdown. A posição
    // sai do botão e fica dentro da tela.
    positionMore() {
      const rect = this.$refs.moreButton?.getBoundingClientRect();
      if (!rect) return;
      const maxLeft = window.innerWidth - MORE_MENU_WIDTH - VIEWPORT_GUTTER;
      const left = Math.max(VIEWPORT_GUTTER, Math.min(rect.left, maxLeft));
      this.moreMenuStyle = { top: `${rect.bottom + 4}px`, left: `${left}px` };
    },

    toggleMore(event) {
      event.stopPropagation();
      this.moreOpen = !this.moreOpen;
      if (this.moreOpen) {
        this.positionMore();
        this.$nextTick(() =>
          this.$refs.moreMenuList?.querySelector('[role="menuitem"]')?.focus()
        );
      }
    },

    isActive(tab) {
      const name = this.$route.name;
      if (tab.key === 'dashboard') {
        return name === 'whatsapp_groups_dashboard';
      }
      if (tab.key === 'groups') {
        return (
          name === 'whatsapp_groups_list' || name === 'whatsapp_group_detail'
        );
      }
      if (tab.key === 'messages' || tab.key === 'adhoc') {
        return name === 'whatsapp_groups_messages';
      }
      if (tab.key === 'sequences') {
        return name === 'whatsapp_groups_sequences';
      }
      if (tab.key === 'campaigns') {
        return (
          name === 'whatsapp_groups_campaigns' ||
          name === 'whatsapp_groups_campaign_detail'
        );
      }
      if (tab.key === 'webhooks') {
        return name === 'whatsapp_groups_webhooks';
      }
      if (tab.key === 'activities') {
        return name === 'whatsapp_groups_activities';
      }
      return false;
    },
  },
};
</script>

<template>
  <!-- A nav rola na horizontal no celular; o menu Mais vai por Teleport para não ser cortado -->
  <section class="flex flex-col w-full h-full bg-n-background">
    <header class="sticky top-0 z-30 px-6 border-b border-n-weak bg-n-solid-1">
      <div class="w-full max-w-6xl mx-auto">
        <div class="flex items-center h-[4.5rem] gap-2">
          <div>
            <span
              class="text-[1.25rem] font-bold tracking-tight text-n-slate-12"
            >
              Grupos WhatsApp
            </span>
            <p class="text-[13px] text-n-slate-11 mt-0.5">
              {{ $t('WORKSPACE_V2.WA_GROUPS.LAYOUT_SUBTITLE') }}
            </p>
          </div>
        </div>
        <nav
          class="flex items-center gap-1 -mb-px overflow-x-auto no-scrollbar"
          @scroll="closeMore"
        >
          <router-link
            v-for="tab in primaryTabs"
            :key="tab.key"
            :to="tab.to"
            :exact="tab.exact"
            class="inline-flex items-center gap-1.5 px-3 py-2.5 text-[13px] font-medium border-b-2 transition-colors whitespace-nowrap"
            :class="
              isActive(tab)
                ? 'border-n-brand text-n-brand'
                : 'border-transparent text-n-slate-11 hover:text-n-slate-12'
            "
          >
            <span class="block size-4 flex-shrink-0" :class="[tab.icon]" />
            {{ tab.label }}
          </router-link>

          <div ref="moreMenu" class="relative z-40 flex-shrink-0">
            <button
              ref="moreButton"
              type="button"
              class="inline-flex items-center gap-1.5 px-3 py-2.5 text-[13px] font-medium border-b-2 transition-colors whitespace-nowrap"
              :class="
                moreActive || moreOpen
                  ? 'border-n-brand text-n-brand'
                  : 'border-transparent text-n-slate-11 hover:text-n-slate-12'
              "
              :aria-expanded="moreOpen ? 'true' : 'false'"
              aria-haspopup="menu"
              @click="toggleMore"
            >
              <span class="i-ri-more-line block size-4 flex-shrink-0" />
              Mais
              <span
                class="block size-3.5"
                :class="
                  moreOpen ? 'i-ri-arrow-up-s-line' : 'i-ri-arrow-down-s-line'
                "
              />
            </button>
            <Teleport to="body">
              <div
                v-if="moreOpen"
                ref="moreMenuList"
                role="menu"
                class="fixed z-50 min-w-64 max-w-[calc(100vw-2rem)] rounded-[var(--workspace-radius,10px)] border border-n-weak bg-n-solid-1 shadow-lg py-1"
                :style="moreMenuStyle"
              >
                <template
                  v-for="(section, sIdx) in moreSections"
                  :key="section.key"
                >
                  <div v-if="sIdx > 0" class="my-1 border-t border-n-weak" />
                  <p
                    v-if="section.label"
                    class="px-3 pt-1.5 pb-1 text-[11px] font-semibold uppercase tracking-wide text-n-slate-10"
                  >
                    {{ section.label }}
                  </p>
                  <router-link
                    v-for="tab in section.items"
                    :key="tab.key"
                    :to="tab.to"
                    role="menuitem"
                    class="flex items-start gap-2 px-3 py-2 text-sm text-n-slate-12 hover:bg-n-alpha-2"
                    :class="isActive(tab) ? 'bg-n-alpha-2 font-medium' : ''"
                    @click="moreOpen = false"
                  >
                    <span
                      class="block size-4 flex-shrink-0 text-n-slate-11 mt-0.5"
                      :class="[tab.icon]"
                    />
                    <span class="flex-1 min-w-0">
                      <span class="flex items-center gap-2">
                        <span>{{ tab.label }}</span>
                        <span
                          v-if="tab.advanced"
                          class="text-[10px] uppercase tracking-wide text-n-slate-10"
                        >
                          avançado
                        </span>
                      </span>
                      <span
                        v-if="tab.description"
                        class="block text-[11px] font-normal text-n-slate-10 mt-0.5 leading-snug"
                      >
                        {{ tab.description }}
                      </span>
                    </span>
                  </router-link>
                </template>
              </div>
            </Teleport>
          </div>
        </nav>
      </div>
    </header>
    <main class="flex-1 min-h-0 overflow-y-auto">
      <router-view />
    </main>
  </section>
</template>
